// Module
var code = "<div ng-if=\"clear_cache.initLoadServerError\"> <a href ng-click=\"clear_cache.clearCacheAndReload($event)\">Clear Cache and Reload</a> </div> ";
// Exports
module.exports = code;